<template>
  <div class="customerManager">
    <!--数据部分-->
    <div class="centerStructure">
      <!--检索条件-->
      <div class="searchBox">
        <span>客户名称：</span>
        <el-input class="cname" v-model.trim="searchForm.userName" placeholder="客户名称" clearable></el-input>
        <span class="inp">是否启用：</span>
        <el-select v-model="searchForm.enable" placeholder="是否启用">
          <el-option
              class="wh140"
              v-for="item in searchForm.enableList"
              :key="item.id"
              :label="item.dictionaryName"
              :value="item.id">
          </el-option>
        </el-select>
        <el-button type="primary" @click="searchButton()" icon="el-icon-search">查询</el-button>
        <el-button type="primary" @click="insert" v-show="$root.$permissionMap.has('SaveCustomer')"
                   icon="el-icon-circle-plus-outline">添加
        </el-button>
      </div>
      <!--表格数据-->
      <el-table
          :data="tableData"
          border
          ref="singleTable"
          style="width: 100%"
          @sort-change="sortChangeMethod"
          height="calc(100% - 84px)">
        <el-table-column
            fixed
            header-align="center"
            align="center"
            type="index"
            width="50">
        </el-table-column>
        <el-table-column
            prop="operation"
            label="操作"
            width="100px"
            align="center"
            header-align="center">
          <template slot-scope="scope">
                        <span class="tableicon" v-show="$root.$permissionMap.has('UpdateCustomer')"><i @click="updateCustomer(scope)" class="el-icon-edit"></i></span>
            <span class="tableicon" v-show="$root.$permissionMap.has('DeleteCustomer')"><i @click="del(scope)" class="el-icon-delete"></i></span>
          </template>
        </el-table-column>
        <template v-for="item in tableTitle">
          <el-table-column
              :align="item.align"
              :header-align="item.halign"
              :key="item.prop"
              :label="item.label"
              :prop="item.prop"
              :width="item.width"
              :sortable="item.sortable"
              :formatter="item.formatter"
              show-overflow-tooltip>
          </el-table-column>
        </template>
      </el-table>
      <!--分页数据-->
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNumber"
          :page-sizes="[20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next"
          :total="pageTotal">
      </el-pagination>
      <!--客户信息弹窗-->
      <el-dialog
          :title="title"
          :visible.sync="openFlag"
          :close-on-click-modal="false"
          :modal-append-to-body="false"
          width="1020px"
      >
        <el-row>
          <el-col :span="18">
            <div class="grid-content bg-purple">
              <!--弹窗左侧信息区域-->
              <div class="formbox">
                <el-form
                    :model="customerDialogForm"
                    :rules="rules"
                    ref="ruleForm"
                    :label-position="labelPosition"
                    label-width="103px"
                >
                  <div class="lintit"><i></i><span>客户基本信息</span></div>
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content bg-purple">
                        <el-form-item label="客户名称：" prop="customerName">
                          <el-input v-model.trim="customerDialogForm.customerName"
                                    placeholder="请输入客户名称"></el-input>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <!--客户类别-->
                    <el-col :span="12">
                      <div class="grid-content bg-purple">
                        <el-form-item label="客户类别：" prop="customerType">
                          <el-select class="halfLineWidth"
                                     v-model="customerDialogForm.customerType"
                                     placeholder="请选择客户级别">
                            <el-option
                                v-for="item in customerDialogForm.customerTypeList"
                                :key="item.id"
                                :label="item.dictionaryName"
                                :disabled="!item.enable"
                                :value="item.id">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </div>
                    </el-col>
                    <!--系统版本-->
                    <el-col :span="12">
                      <div class="grid-content bg-purple">
                        <el-form-item label="系统版本：" prop="systemVersion">
                          <el-select class="halfLineWidth"
                                     v-model="customerDialogForm.systemVersion"
                                     placeholder="请选择系统版本">
                            <el-option
                                v-for="item in customerDialogForm.systemVersionList"
                                :key="item.id"
                                :label="item.dictionaryName"
                                :disabled="!item.enable"
                                :value="item.id">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </div>
                    </el-col>

                  </el-row>
                  <el-row>
                    <el-col :span="8">
                      <el-form-item label="所在省：" prop="provinces">
                        <el-select class="thirdLineWidth" v-model="customerDialogForm.provinces"
                                   placeholder="请选择省份" :disabled="disabledFlag" filterable
                                   @change="getChildrenRegion('urban','')">
                          <el-option v-for="item in customerDialogForm.provinceList"
                                     :key="item.id"
                                     :label="item.regionName"
                                     :value="item.id"
                                     @click.native="changeAreaName(item.regionName)"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="所在市：" prop="urban">
                        <el-select class="thirdLineWidth" v-model="customerDialogForm.urban"
                                   placeholder="请选择地市" :disabled="disabledFlag" clearable
                                   filterable
                                   @change="getChildrenRegion('district','')">
                          <el-option v-for="item in customerDialogForm.urbanList"
                                     :key="item.id"
                                     :label="item.regionName"
                                     :value="item.id"
                                     @click.native="changeAreaName(item.regionName)"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="所在区：" prop="district">
                        <el-select class="thirdLineWidth" v-model="customerDialogForm.district"
                                   clearable filterable
                                   placeholder="请选择区县" :disabled="disabledFlag">
                          <el-option v-for="item in customerDialogForm.districtList"
                                     :key="item.id"
                                     :label="item.regionName"
                                     :value="item.id"
                                     @click.native="changeAreaName(item.regionName)"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <div class="grid-content bg-purple">
                        <el-form-item label="管理员账号：" prop="adminAccount">
                          <el-input class="userAcc"
                                    v-model.trim="customerDialogForm.adminAccount"
                                    placeholder="请输入管理员账号" :disabled="adminAccountFlag">
                            <el-button slot="append" :disabled="resDisFlag"
                                       @click="resetAdminAccount">重置密码
                            </el-button>
                          </el-input>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div class="grid-content bg-purple">
                        <el-form-item label="经纬度：" prop="longitudeAndLatitude">
                          <el-input v-model="customerDialogForm.longitudeAndLatitude" disabled
                                    placeholder="请设置经纬度">
                            <el-button slot="append" @click="setUpLatitudeAndLongitude">
                              设置经纬度
                            </el-button>
                          </el-input>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content bg-purple">
                        <el-form-item label="详细地址：" prop="address">
                          <el-input v-model.trim="customerDialogForm.address"
                                    placeholder="请输入详细地址"></el-input>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <div class="grid-content bg-purple">
                        <el-form-item label="启用状态：" prop="enableFlag">
                          <el-radio-group v-model="customerDialogForm.enableFlag">
                            <el-radio :label="true" border>启用</el-radio>
                            <el-radio :label="false" border>禁用</el-radio>
                          </el-radio-group>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div class="grid-content bg-purple">
                        <el-form-item label="排序码：" prop="sortCode">
                          <el-input class="halfLineWidth"
                                    v-model.trim="customerDialogForm.sortCode"
                                    placeholder="请输入排序码，1-999之间"></el-input>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <!--推送地址-->
                    <el-col :span="16">
                      <div class="grid-content bg-purple">
                        <el-form-item label="推送地址：" prop="pushUrl">
                          <el-input v-model.trim="customerDialogForm.pushUrl"
                                    placeholder="请输入推送地址"></el-input>
                        </el-form-item>
                      </div>
                    </el-col>
                    <!--客户编码-->
                    <el-col :span="8">
                      <div class="grid-content bg-purple">
                        <el-form-item label="客户编码：" prop="customerCode">
                          <el-input v-model.trim="customerDialogForm.customerCode"
                                    placeholder="请输入客户编码"></el-input>
                        </el-form-item>
                      </div>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
            </div>
          </el-col>
          <el-col :span="6" class="tree-scroll">
            <div class="grid-content bg-purple-light">
              <!--弹窗右侧权限树选择-->
              <div>
                <tree
                    ref="tree"
                    title="权限设置"
                    :treeEdit="false"
                    node-key="id"
                    :showCheckbox="true"
                    :sourceData="customerDialogForm.sourceData"
                    :formatTreeData="customerDialogForm.jsonTree"
                    :strictly="false"
                    :defExpandNode="customerDialogForm.expandArr"
                    @freshTreeData="getPermissionTree"
                ></tree>
              </div>
            </div>
          </el-col>
        </el-row>
        <!--弹窗脚部分-->
        <span slot="footer" class="dialog-footer">
                <el-button @click="resetForm('ruleForm')">取 消</el-button>
                <el-button type="primary" @click="submitForm('ruleForm')" :loading="btnLoadingFlag">提 交</el-button>
           </span>
      </el-dialog>
      <!--地图弹窗-->
      <el-dialog :title='maptitle'
                 :visible.sync="opendiamapflag"
                 :close-on-click-modal="true"
                 :modal-append-to-body="false"
                 width="1000px">
        <!--引入地图子组件-->
        <gdmap style="height: 500px" @transferFromGdMap='setUpLngLat' :areaName="searchAreaName"
               v-bind:FatherLngLat="FatherLngLat"
               :key="timer"></gdmap>
      </el-dialog>
    </div>

  </div>
</template>
<!--js部分-->
<script>
import {Mixins} from '@/config/mixins/mixins'
import {$http} from '@/config/api/axios'
import SearchDialog from '@/components/custom/Searchdialog'
import Tree from "@/components/common/Tree";
import {IsInteger, IsNull} from "@/config/validate/common";
import gdmap from "@/components/common/GdMap";

export default {
  name: 'customerManager',   // 修饰的是这个页面
  mixins: [Mixins],  //混入公共方法,慎用.
  components: {
    SearchDialog,  //引入高级查询弹窗
    Tree, //引入树组件
    gdmap  //高德地图
  },
  data() {
    //判断是否为数字
    let isNumber = (rule, value, callback) => {
      if (!IsInteger(value) && value !== '') {
        callback(new Error('请输入整数数字值'));
      } else {
        callback();
      }
    };
    //是否启用转化
    let isEnableFormat = (row, column, cellValue, index) => {
      if (true === cellValue) {
        cellValue = '是';
      } else {
        cellValue = '否';
      }
      return cellValue;
    };
    //是否对接转化
    let isDockingFormat = (row, column, cellValue, index) => {
      if (!IsNull(cellValue)) {
        cellValue = '是';
      } else {
        cellValue = '否';
      }
      return cellValue;
    };
    return {

      //上传图片相关
      uploadURL: '',
      updateImgArr: [],
      picList: [],
      fileType: [],   // 允许图片类型数组
      thumbPic: '',
      realPic: '',
      //路径
      host: 'http://' + window.location.host + this.prefix + '/basic',
      //编辑时的客户id中间值
      midCustomerId: "",

      //权限按钮设置
      insertPerFlag: false,
      updatePerFlag: false,
      delPerFlag: false,

      adminAccountFlag: false, //管理员账号disable标志
      dueDateDisFlag: false,     //到期时间disable标志
      searchAreaName: "",
      //按钮loading标识
      btnLoadingFlag: false,
      //重置密码按钮是否可用标识
      resDisFlag: false,
      //省市区中间值
      addressMidData: {
        provinces: '',//省份
        urban: '',//地市
        district: '', //区县
      },
      //省市区父id
      parentId: 100000,
      //省市区禁用标识
      disabledFlag: false,
      //控制重新渲染子组件
      timer: '',
      //经纬度
      FatherLngLat: null,
      isShow: false,
      customerDeviceData: [], //设备数据
      //对应设备信息
      customerDevice: {
        deviceTypeName: '',
        deviceCount: 0,
        deviceId: '',
      },
      //列表表头
      tableTitle: [
        {prop: "customerName", label: '客户名称', width: '', align: 'left', halign: 'center', show: true,},
        {prop: "customerType", label: '客户类型', width: '80', align: 'center', halign: 'center', show: true,},
        {prop: "systemVersion", label: '系统版本', width: '150', align: 'center', halign: 'center', show: true,},
        {prop: "regionName", label: '省市区', width: '150', align: 'center', halign: 'center', show: true},
        {prop: "adminAccount", label: '管理员账号', width: '150', align: 'center', halign: 'center', show: true},
        {
          prop: "enableFlag",
          label: '启用',
          width: '70',
          align: 'center',
          halign: "center",
          show: true,
          'formatter': isEnableFormat
        },
        {
          prop: "pushUrl",
          label: '是否对接',
          width: '100',
          align: 'center',
          halign: "center",
          show: true,
          'formatter': isDockingFormat
        },
        {prop: "loginName", label: '创建人', width: '150', align: 'center', halign: 'center', show: true},
        {prop: "createTime", label: '创建时间', width: '160', align: 'center', halign: 'center', show: true},
      ],
      tableData: [],  //列表数据
      searchForm: {
        userName: '',
        enableList: [
          {"id": 0, "dictionaryName": "全部"},
          {"id": 1, "dictionaryName": "是"},
          {"id": 2, "dictionaryName": "否"},
        ],
        enable: 0,
        orderType: "",
        orderColumn: "",
      },
      //分页数据设置
      pageSize: 20, //条数
      pageNumber: 1,
      pageTotal: 0, //总页数
      //地图
      maptitle: '设置经纬度',//地图弹窗标题
      opendiamapflag: false,//地图弹窗是否打开
      // 弹窗表单字段
      title: '客户信息',  //弹窗标题
      openFlag: true, //是否打开弹窗标志
      labelPosition: 'right', //表单域标签的位置，如果值为 left 或者 right 时，则需要设置 label-width
      customerDialogForm: {
        provinces: '',//省份
        provinceList: [], //省份集合
        urban: '',//地市
        urbanList: [],//地市集合
        district: '', //区县
        districtList: [], //区县集合
        id: '', //客户id
        userId: '', //用户id
        customerName: '',
        firstCustomerName: '',//第一次用户名称
        address: '', //详细地址
        regionName: [], //省市区
        customerType: 1001001, //客户类别
        customerTypeList: [],
        adminAccount: '', //管理员账号
        longitudeAndLatitude: '', //经纬度
        enableFlag: true, //启用标志
        sortCode: 1, //排序码
        pushUrl: '',//推送地址
        customerCode: '', //客户编码
        systemVersion: 1002001, //系统版本
        systemVersionList: [],
        //权限树
        expandArr: [],
        sourceData: [],
        jsonTree: {},
        //选择的权限对象列表
        permissionList: [],
      },
      rules: {
        customerName: [{required: true, message: '客户名称不能为空', trigger: 'blur'},
          {max: 30, message: '长度不超过30个汉字或字符', trigger: 'blur'}],
        customerCode: [{required: false, message: '客户编码不能为空', trigger: 'blur'},
          {max: 20, message: '长度不超过20个数字', trigger: 'blur'},
          {pattern: /(^[1-9]\d*$)/, message: "请输入正整数", trigger: "blur",}
        ],
        provinces: [{required: true, message: '所属省份不能为空', trigger: 'change'},],
        urban: [{required: true, message: '所属地市不能为空', trigger: 'change'},],
        address: [{max: 50, message: '长度不超过50个汉字或字符', trigger: 'blur'}],
        adminAccount: [{required: true, message: '管理员账号不能为空', trigger: 'blur'},
          {pattern: /^[a-zA-Z0-9_-]{1,20}$/, message: "账户限制20个字符支持字母/数字/减号/下划线", trigger: "blur",}],
        sortCode: [
          {required: true, message: '排序码不能为空', trigger: 'blur'},
          {validator: isNumber, trigger: 'blur'},
          {pattern: /^\+?[1-9]{1}[0-9]{0,2}\d{0,0}$/, message: "只允许输入1-999的数字", trigger: "blur",}],
        pushUrl: [{max: 100, message: '长度不超过100个汉字或字符', trigger: 'blur'},
          {
            pattern: /(http|https|HTTP|HTTPS):\/\/([\w.]+\/?)\S*/,
            message: "不是以http://https://开头，或者不是网址！",
            trigger: "blur",
          },
        ],
      },
      //添加或者编辑标志
      isEdit: false,
      tableDragVisible: false, //字段是否可拖拽 默认为false
    }
  },
  //监听部分
  watch: {

    //当推送地址不为空,客户编码为必填
    "customerDialogForm.pushUrl": function (newval, oldval) {
      this.rules.customerCode[0].required = !IsNull(newval);
    },


  },
  methods: {

    //表格排序改变方法
    sortChangeMethod(object) {
      this.searchForm.orderType = object.order;
      this.searchForm.orderColumn = object.prop;
      this.getCustomerList();
    },
    //设置表单初始状态值
    setDefaultDialogValue() {
      this.customerDialogForm.provinces = '';
      this.customerDialogForm.urban = '';
      this.customerDialogForm.district = '';
      this.customerDialogForm.id = '';
      this.customerDialogForm.userId = '';
      this.customerDialogForm.customerName = '';
      this.customerDialogForm.firstCustomerName = '';
      this.customerDialogForm.address = '';
      this.customerDialogForm.customerType = 1001001;
      this.customerDialogForm.customerCode = '';
      this.customerDialogForm.adminAccount = '';
      this.customerDialogForm.longitude = '';
      this.customerDialogForm.longitudeAndLatitude = '';
      this.customerDialogForm.enableFlag = true;
      this.customerDialogForm.sortCode = 1;
      this.customerDialogForm.pushUrl = "";
      this.customerDialogForm.systemVersion = 1002001
    },
    //根据选中坐标改变地址值
    changeAreaName(val) {
      this.searchAreaName = val;
    },
    //赋值经纬度和地理位置信息
    setUpLngLat(mapData) {
      this.opendiamapflag = false;
      if (mapData != null) {
        //经纬度
        this.customerDialogForm.longitudeAndLatitude = mapData.lngLat;
        //地理位置信息
        if (mapData.address != null && mapData.address !== "") {
          this.customerDialogForm.address = mapData.address;
        }
      }
    },
    //设置经纬度弹窗
    setUpLatitudeAndLongitude() {
      this.timer = new Date().getTime();
      this.opendiamapflag = true;
      this.maptitle = "设置经纬度";
      this.FatherLngLat = this.customerDialogForm.longitudeAndLatitude;
    },
    //查询下级子节点
    getChildrenRegion(val, isEdit) {
      let _this = this;
      let param = {};
      if (val === "urban") {
        _this.parentId = _this.customerDialogForm.provinces;
        _this.customerDialogForm.urbanList = [];
        _this.customerDialogForm.districtList = [];
        //如果是编辑状态,不可改为空字符串
        if (isEdit === "") {
          _this.customerDialogForm.urban = '';
          _this.customerDialogForm.district = '';
        } else if (isEdit === "edit") {
          _this.parentId = _this.addressMidData.provinces;
        }
      } else if (val === "district") {
        _this.parentId = _this.customerDialogForm.urban;
        _this.customerDialogForm.districtList = [];
        if (isEdit === "") {
          _this.customerDialogForm.district = '';
        } else if (isEdit === "edit") {
          _this.parentId = _this.addressMidData.urban;
        }
      }
      param.parentId = _this.parentId;
      if (IsNull(param.parentId)) {
        return;
      }
      $http("get", "region/getChildrenRegion", param)
          .then((res) => {
            if (val === "provinces") {
              _this.customerDialogForm.provinceList = [];
              for (let i = 0; i < res.data.length; i++) {
                _this.customerDialogForm.provinceList.push(res.data[i]);
              }
            } else if (val === "urban") {
              _this.customerDialogForm.urbanList = [];
              for (let i = 0; i < res.data.length; i++) {
                _this.customerDialogForm.urbanList.push(res.data[i]);
              }
              if (isEdit === "edit") {
                _this.customerDialogForm.urban = _this.addressMidData.urban;
              }
            } else {
              _this.customerDialogForm.districtList = [];
              for (let i = 0; i < res.data.length; i++) {
                _this.customerDialogForm.districtList.push(res.data[i]);
              }
              if (isEdit === "edit") {
                _this.customerDialogForm.district = _this.addressMidData.district;
              }
            }
          })
    },
    //查询按钮
    searchButton() {
      this.handleCurrentChange(1);
    },
    //查询客户列表数据
    getCustomerList(checkCode) {
      if (IsNull(checkCode)) {
        this.selfLoadingOpen('.customerManager');
      }
      this.tableData = [];
      let params = {};
      params.pageSize = this.pageSize;
      params.pageNumber = this.pageNumber;
      params.userName = this.searchForm.userName.trim();
      params.enable = this.searchForm.enable;
      $http("get", "customerInfo/listCustomers", params)
          .then((res) => {
            if (res.status === 'SUCCESS') {
              for (let i = 0; i < res.data.length; i++) {
                this.tableData.push(res.data[i]);
              }
              this.pageTotal = res.count;
            } else if (res.status === 'NORESOURCES') {
              this.tableData = [];
              this.pageTotal = 0;
            } else {
              this.msgerror(res.message);
            }
            this.selfLoadingClose(); //关闭遮罩
          });
    },
    //查询客户类别下拉框
    getCustomerTypeSelect() {
      let param = {};
      param.typeId = 1001;
      $http("get", "dictionary/listDictionaryByTypeId", param)
          .then((res) => {
            if (res.status === 'SUCCESS') {
              for (let i = 0; i < res.data.length; i++) {
                if (res.data[i].id === 1001001 || res.data[i].id === 1001002) {
                  this.customerDialogForm.customerTypeList.push(res.data[i])
                }
              }
            } else {
              this.msgerror(res.message);
            }
          })
    },
    //查询系统版本下拉框
    getSystemVersionSionSelect() {
      let param = {};
      param.typeId = 1002;
      $http("get", "dictionary/listDictionaryByTypeId", param)
          .then((res) => {
            if (res.status === 'SUCCESS') {
              for (let i = 0; i < res.data.length; i++) {
                this.customerDialogForm.systemVersionList.push(res.data[i])
              }
            } else {
              this.msgerror(res.message);
            }
          })
    },
    //查询权限树相关信息
    getPermissionTree() {
      let params = {
        permissionTypeId: 1,
      };
      $http("get", "authority/listAllAuthority", params)
          .then((result) => {
            if (result.status === 'SUCCESS') {
              result.data.unshift({
                addIcon: true,
                authorityCode: "0",
                authorityEnName: "name",
                authorityId: 0,
                authorityName: "所有权限",
                authorityParentCode: "-1",
                authorityType: 1,
                delIcon: false,
                editIcon: false,
              });
              this.customerDialogForm.sourceData = result.data;
            } else {
              this.msgerror(result.message);
            }
          });
      this.customerDialogForm.jsonTree = {
        id: "authorityId",
        label: "authorityName",
        pcode: "authorityParentCode",
        code: "authorityCode",
        type: "authorityType",
      };
    },
    //清空选中节点
    clearTree() {
      let checkedNodes = this.$refs.tree.getCheckedNodes();
      let halfCheckedNodes = this.$refs.tree.getHalfCheckedNodes();
      if (halfCheckedNodes.length > 0) {
        checkedNodes.push(...halfCheckedNodes)
      }
      for (let i = 0; i < checkedNodes.length; i++) {
        this.$refs.tree.setChecked(checkedNodes[i].id, false)
      }
      this.$nextTick(() => {
        this.$refs['tree'].clearFilter(); //清空检索条件
      });
      this.$refs.tree.collapseAll()
    },
    //点击添加按钮
    insert() {
      this.$refs['ruleForm'].resetFields(); //清空表单
      this.clearTree();
      this.isEdit = false; //设置标志位为添加
      this.resDisFlag = true; //重置管理员按钮的禁用是否启用
      this.customerDeviceData = []; //先把设备类型置空,在进行查询
      this.customerDialogForm.districtList = [];
      this.customerDialogForm.provinceList = [];
      this.customerDialogForm.urbanList = [];
      this.parentId = 100000;
      this.adminAccountFlag = false;
      this.customerDialogForm.expandArr = [0]; //展开根节点
      this.getChildrenRegion('provinces', '');
      this.openFlag = true;//打开弹窗
    },
    //删除方法 有设备不能删除,没有设备删除客户和权限.
    del(scope) {
      this.$confirm('此操作耗时较长且将删除当前客户的所有数据并不可恢复，建议在非业务高峰期操作，确认要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: ''
      }).then(() => {
        this.selfLoadingOpen(".customerManager");
        let param = {};
        param.customerId = scope.row.id;
        $http("POST", "customerInfo/deleteCustomer", param)
            .then((res) => {
              if (res.status === 'SUCCESS') {
                if (this.tableData.length === 1 && this.pageNumber > 1) {
                  this.pageNumber--;
                }
                this.msgsuccess('删除成功。');
                this.getCustomerList("del");
              } else {
                this.msgerror(res.message)
                this.selfLoadingClose();
              }
            });
      }).catch(() => {
      });
    },
    //通过客户id查询对应权限树
    getEditPermissionTreeById(id) {
      let param = {
        customerId: id,
      };
      $http("get", "customerPermission/getCustomerPermissionById", param).then((result) => {
        if (result.status === 'SUCCESS') {
          for (let i = 0; i < result.data.length; i++) {
            let node = this.$refs.tree.getNode(result.data[i].moduleId);
            if (node.childNodes == null || node.childNodes.length <= 0) {
              this.$refs.tree.setChecked(result.data[i].moduleId, true, true);
            }
          }
        } else {
          this.msgerror(result.message);
        }
      });
    },
    //通过客户id查询客户信息
    getCustomerById(id) {
      let param = {
        customerId: id,
      };
      $http("get", "customerInfo/getCustomerById", param)
          .then((res) => {
            if (res.status === 'SUCCESS') {
              this.customerDialogForm.id = res.data.id;
              this.customerDialogForm.customerName = res.data.customerName;
              this.customerDialogForm.address = res.data.address;
              this.customerDialogForm.userId = res.data.userId;
              this.addressMidData.provinces = res.data.regionIdGroup[0];
              let length = res.data.regionIdGroup.length;
              this.customerDialogForm.provinces = res.data.regionIdGroup[0];
              if (length > 2) {
                this.addressMidData.urban = res.data.regionIdGroup[1];
                this.addressMidData.district = res.data.regionIdGroup[2];
                this.getChildrenRegion("urban", "edit");
                this.getChildrenRegion("district", "edit");
              } else {
                this.addressMidData.urban = res.data.regionIdGroup[1];
                this.getChildrenRegion("urban", "edit");
                this.getChildrenRegion("district", "edit");
              }
              if (!IsNull(res.data.customerCode)) {
                this.customerDialogForm.customerCode = res.data.customerCode.toString();
              } else {
                this.customerDialogForm.customerCode = null;
              }
              this.customerDialogForm.pushUrl = res.data.pushUrl;
              this.customerDialogForm.customerType = res.data.customerTypeId;
              this.customerDialogForm.systemVersion = res.data.systemVersionId;
              this.customerDialogForm.adminAccount = res.data.adminAccount;
              this.customerDialogForm.longitudeAndLatitude = res.data.longitudeAndLatitude;
              this.customerDialogForm.enableFlag = res.data.enableFlag;
              this.customerDialogForm.sortCode = res.data.sortCode;
              this.customerDialogForm.newCustomerName = res.data.customerName;
            } else {
              this.msgerror(res.message);
            }

          });
    },
    //编辑按钮
    updateCustomer(scope) {
      this.$refs['ruleForm'].resetFields(); //清空表单
      this.getPermissionTree();
      this.isEdit = true; //设置标志位为true
      this.resDisFlag = false; //重置管理员按钮的是否启用
      this.customerDeviceData = []; //清空设备表格数据
      this.customerDialogForm.districtList = [];
      this.customerDialogForm.provinceList = [];
      this.customerDialogForm.urbanList = [];
      this.customerDialogForm.provinces = "";
      this.customerDialogForm.urban = "";
      this.customerDialogForm.district = "";
      this.addressMidData.provinces = "";
      this.addressMidData.urban = "";
      this.addressMidData.district = "";
      this.parentId = 100000;
      this.adminAccountFlag = true;
      this.customerDialogForm.expandArr = [0]; //展开根节点
      this.$nextTick(() => {
        setTimeout(() => {
          this.getChildrenRegion('provinces', '');
          this.getCustomerById(scope.row.id); //查询单例方法
          this.getEditPermissionTreeById(scope.row.id);
          this.midCustomerId = scope.row.id; //编辑时记录一下客户id中间值.
          this.openFlag = true; //打开弹窗
        }, 500);

      });
    },
    //重置管理员账户
    resetAdminAccount() {
      this.$confirm('此操作将管理员密码重置为 "111111"，确认要重置吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: ''
      }).then(() => {
        let param = {
          userId: this.customerDialogForm.userId,
        };
        $http("POST", "user/resetPassword", param)
            .then((res) => {
              if (res.status === "SUCCESS") {
                this.msgsuccess('已重置。');
              } else {
                this.msgerror('重置失败。');
              }
            })
      }).catch(() => {
      });
    },
    //提交
    submitForm(ref) {
      this.$refs[ref].validate((valid) => {
        let param = {};
        if (valid) {
          //权限树
          this.customerDialogForm.permissionList = [];
          let checkedNodes = this.$refs.tree.getCheckedNodes();
          let halfCheckedNodes = this.$refs.tree.getHalfCheckedNodes();
          if (halfCheckedNodes.length > 0) {
            checkedNodes.push(...halfCheckedNodes);
          }
          checkedNodes.forEach(item => {
            if (item.id !== 0) {
              this.customerDialogForm.permissionList.push({moduleId: item.id, typeId: item.type});
            }
          });
          //添加方法请求
          param.oldCustomerName = this.customerDialogForm.firstCustomerName;
          param.customerName = this.customerDialogForm.customerName;
          param.address = this.customerDialogForm.address;
          if (this.customerDialogForm.district === '') {
            param.regionId = this.customerDialogForm.urban;
          } else {
            param.regionId = this.customerDialogForm.district;
          }
          param.customerTypeId = this.customerDialogForm.customerType;
          param.adminAccount = this.customerDialogForm.adminAccount;
          param.longitudeAndLatitude = this.customerDialogForm.longitudeAndLatitude;
          param.enableFlag = this.customerDialogForm.enableFlag;
          param.customerCode = this.customerDialogForm.customerCode;
          param.sortCode = this.customerDialogForm.sortCode;
          param.pushUrl = this.customerDialogForm.pushUrl;
          param.systemVersionId = this.customerDialogForm.systemVersion
          param.permissionList = this.customerDialogForm.permissionList;
          if (param.permissionList.length <= 0) {
            this.msgwarning('请为用户分配权限。');
            return;
          }
          this.btnLoadingFlag = true;
          if (!this.isEdit) {
            $http("POST", "customerInfo/saveCustomer", param).then((res) => {
              this.btnLoadingFlag = false;
              if (res.status === "SUCCESS") {
                this.$refs[ref].resetFields(); //清空表单
                this.msgsuccess(res.message);
                this.openFlag = false;
                this.searchButton();
              } else {
                this.msgerror(res.message);
              }
            });
          } else {
            //编辑方法
            param.id = this.customerDialogForm.id;
            $http("POST", "customerInfo/updateCustomer", param)
                .then((res) => {
                  this.btnLoadingFlag = false;
                  if (res.status === "SUCCESS") {
                    this.$refs[ref].resetFields(); //清空表单
                    this.msgsuccess(res.message);
                    this.openFlag = false;
                    this.searchButton();
                  } else {
                    this.msgerror(res.message);
                  }
                });
          }
        } else {
          this.$nextTick(() => {
            let isError = document.getElementsByClassName("is-error");
            isError[0].querySelector('input').focus();
            return false;
          });
        }
      })
    },
    //表单取消按钮
    resetForm() {
      this.openFlag = false;
    },
    //切换页面方法
    handleSizeChange(val) {
      this.pageSize = val;
      this.handleCurrentChange(1);
    },
    handleCurrentChange(val) {
      this.pageNumber = val;
      this.getCustomerList();
    },
  },

  created() {
    this.setDefaultDialogValue();
    this.getCustomerList();
    this.getSystemVersionSionSelect();
    this.getCustomerTypeSelect();
    this.$nextTick(() => {
      this.customerDialogForm.expandArr = [0];
      this.openFlag = false;
    })
  },
  mounted() {

  },
  activated() {
    if (!!this.$refs['singleTable']) {
      this.$refs.singleTable.doLayout();
    }
  },
}
</script>
<!--css部分-->
<style lang="less">
.customerManager {
  width: 100%;
  height: 100%;
  margin-bottom: 10px;
  display: flex;
  position: relative;

  .formbox {
    .lineWidth {
      width: 520px;
    }

    .halfLineWidth {
      width: 255px;
    }

    .thirdLineWidth {
      width: 135px;
    }

    .upload-demo .el-upload-list {
      width: 150px;
      height: 32px;
    }

    .upload-demo .el-upload-list > li {
      width: 145px;
      margin: 0;
      line-height: 30px;
      outline: none;
    }

    .upload-demo .el-upload {
      position: absolute;
      top: 0px;
      left: 160px;
    }
  }

  /*到期日期*/

  .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 255px;
  }

  .tree-box {
    height: 100%;
  }

  .tree-scroll {
    height: 367px;
    overflow: auto;
    overflow-x: hidden;
    border: 1px solid #ebeef5;
  }

  .el-dialog__body {
    padding-right: 20px;
  }
}

// 主题切换后权限树的样式变化
.theme2 {
  .customerManager .tree-scroll {
    border-color: #494949;
  }
}

</style>